/* tslint:disable */
// core
import '@nextiva/amcharts'; // chart types

import '@nextiva/amcharts/amcharts/serial';
import '@nextiva/amcharts/amcharts/pie';
import '@nextiva/amcharts/amcharts/xy';
import '@nextiva/amcharts/amcharts/funnel'; // for chart of type 'map'

import '@nextiva/amcharts/ammap/ammap';
import '@nextiva/amcharts/ammap/maps/js/usaLow'; // plugins

import '@nextiva/amcharts/amcharts/plugins/export';
import '@nextiva/amcharts/amcharts/plugins/responsive';
import AmCharts from '@amcharts/amcharts3-react';
import "./AmCharts.css";
export default AmCharts;
export * from '@amcharts/amcharts3-react';
import { debounceRender } from '@nextiva/analytics-common';
AmCharts.React = debounceRender(AmCharts.React, 700, {
  leading: true
});